export const format = (price: number | undefined): number => {
  return price === undefined ? 0 : price / 100;
};
